import { graphql } from '../graphql';

export const weblinkFragment = graphql(`
  fragment WebLink on WebLink {
    __typename
    title
    url
    isExternal
    variant
    iconInfo {
      name
      placement
    }
    callout {
      text
      variant
    }
    tracking {
      outboundTracking {
        schema
        data {
          event_name
          type
          click_url
        }
      }
      clickThroughTracking {
        pathname
        page
        element
        sourceType
      }
    }
    key
    disabled
    rel
  }
`);
